import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';
import { uaToDeviceType, uaToOSName } from './userAgent';
import { CLIENT_DEFAULT_DOLLAR_AMOUNT, TIMEOUT_PLTV_FETCH } from './constants';

var fetchWithTimeout = function fetchWithTimeout(token, osName, deviceType) {
  var promise = fetch(window._eePltvConfigV2.PLTV_URL, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      entry_token: token,
      user_agent: {
        os_name: osName,
        device_type: deviceType
      }
    })
  });
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject('Fetch timeout');
    }, TIMEOUT_PLTV_FETCH);
    promise.then(resolve, reject);
  });
};

var calculatePltv =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var urlString, uaString, entryToken, deviceType, osName, url, token, response, data, default_dollar_amount;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            urlString = _ref.urlString, uaString = _ref.uaString, entryToken = _ref.entryToken;
            deviceType = uaToDeviceType(uaString);
            osName = uaToOSName(uaString);
            url = new URL(urlString);
            token = entryToken || url.searchParams.get('entry_token');
            _context.prev = 5;
            _context.next = 8;
            return fetchWithTimeout(token, osName, deviceType);

          case 8:
            response = _context.sent;
            _context.prev = 9;
            _context.next = 12;
            return response.json();

          case 12:
            data = _context.sent;
            default_dollar_amount = data.default_conversion_dollar_amount || CLIENT_DEFAULT_DOLLAR_AMOUNT;

            if (!response.ok) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", {
              debug_mode: data.debug_mode,
              pltv: data.success ? data.data.predicted_revenue : default_dollar_amount,
              default_value: !data.success
            });

          case 18:
            return _context.abrupt("return", {
              debug_mode: data.debug_mode,
              pltv: default_dollar_amount,
              default_value: true
            });

          case 19:
            _context.next = 24;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](9);
            return _context.abrupt("return", {
              debug_mode: true,
              pltv: CLIENT_DEFAULT_DOLLAR_AMOUNT,
              default_value: true
            });

          case 24:
            _context.next = 33;
            break;

          case 26:
            _context.prev = 26;
            _context.t1 = _context["catch"](5);

            if (!window.pltvSentry) {
              _context.next = 32;
              break;
            }

            window.pltvSentry.captureMessage(_context.t1, 'warning');
            _context.next = 32;
            return window.pltvSentry.flush(2000);

          case 32:
            return _context.abrupt("return", {
              debug_mode: true,
              pltv: CLIENT_DEFAULT_DOLLAR_AMOUNT,
              default_value: true
            });

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 26], [9, 21]]);
  }));

  return function calculatePltv(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export { calculatePltv };